import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useOperators } from './operators';

/**
 * Composable that provides knowledge base FAQ filtering context
 * @returns {{ filterTypes: import('vue').ComputedRef }}
 */
export function useKnowledgeBaseFaqFilterContext() {
  const { t } = useI18n();

  const { equalityOperators, containmentOperators, dateOperators } =
    useOperators();

  /**
   * @type {import('vue').ComputedRef}
   */
  const filterTypes = computed(() => [
    {
      attributeKey: 'question',
      value: 'question',
      attributeName: t('PILOT.KNOWLEDGE_BASES.FAQS.TABLE_QUESTION'),
      label: t('PILOT.KNOWLEDGE_BASES.FAQS.TABLE_QUESTION'),
      inputType: 'plainText',
      dataType: 'text',
      filterOperators: containmentOperators.value,
      attributeModel: 'standard',
    },
    {
      attributeKey: 'status',
      value: 'status',
      attributeName: t('PILOT.KNOWLEDGE_BASES.FAQS.TABLE_STATUS'),
      label: t('PILOT.KNOWLEDGE_BASES.FAQS.TABLE_STATUS'),
      inputType: 'searchSelect',
      options: [
        {
          id: 'draft',
          name: t('PILOT.KNOWLEDGE_BASES.FAQS.STATUS_DRAFT'),
        },
        {
          id: 'published',
          name: t('PILOT.KNOWLEDGE_BASES.FAQS.STATUS_PUBLISHED'),
        },
      ],
      dataType: 'text',
      filterOperators: equalityOperators.value,
      attributeModel: 'standard',
    },
    {
      attributeKey: 'created_at',
      value: 'created_at',
      attributeName: t('PILOT.KNOWLEDGE_BASES.FAQS.TABLE_CREATED_AT'),
      label: t('PILOT.KNOWLEDGE_BASES.FAQS.TABLE_CREATED_AT'),
      inputType: 'date',
      dataType: 'text',
      filterOperators: dateOperators.value,
      attributeModel: 'standard',
    },
    {
      attributeKey: 'updated_at',
      value: 'updated_at',
      attributeName: t('PILOT.KNOWLEDGE_BASES.FAQS.TABLE_UPDATED_AT'),
      label: t('PILOT.KNOWLEDGE_BASES.FAQS.TABLE_UPDATED_AT'),
      inputType: 'date',
      dataType: 'text',
      filterOperators: dateOperators.value,
      attributeModel: 'standard',
    },
  ]);

  return { filterTypes };
}
